<template>
  <swiper :options="swiperOption">
    <swiper-slide
      v-for="(item,index) in imgList"
      :key="(index+1)*30"
      :class="deletebnt?'file-box-item-bnt':'file-box-item'"
    >
      <div v-if="deletebnt">
        <div @click="$parent.deleteimg(index)" class="close-bnt"></div>
        <div class="img-box">
          <img @click="$parent.previewImage(item)" :src="item" />
        </div>
      </div>
      <img v-else @click="$parent.previewImage(item)" :src="item" />
    </swiper-slide>
    <swiper-slide
      v-for="(item,index) in fileList"
      :key="index"
      :class="deletebnt?'file-box-item-bnt':'file-box-item'"
    >
      <div v-if="deletebnt">
        <div @click="$parent.deletefile(index)" class="close-bnt"></div>
        <div class="img-box">
          <div class="title">{{item.fileName}}</div>
          <div class="bottom-box">
            <div class="icon" :class="'fileformat-'+item.filefromat"></div>
            <div class="size">5.67MB</div>
          </div>
        </div>
      </div>
      <div class="file-box-item" v-else>
        <div class="title">{{item.fileName}}</div>
        <div class="bottom-box">
          <div class="icon" :class="'fileformat-'+item.filefromat"></div>
          <div class="size">5.67MB</div>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>
<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: "1.6%",
        onTransitionEnd: function(swiper) {
          if (swiper.progress == 1) {
            swiper.activeIndex = swiper.slides.length - 1;
          }
        }
      }
    };
  },
  props: {
    deletebnt: false,
    fileList: {
      type: Array,
      default() {
        return [];
      }
    },
    imgList: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>
<style lang="less" scoped>
.file-box-item-bnt {
  position: relative;
  width: 2.533333rem;
  height: 2.533333rem;
  margin-right: 0.2rem;
  margin-bottom: 0.2667rem;
  .img-box {
    width: 2.133333rem;
    height: 2.133333rem;
    display: flex;
    flex-direction: column;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .close-bnt {
    margin-left: 2.133333rem;
    width: 0.4rem;
    height: 0.4rem;
    background: url("../../../assets/icon/icon-delete.png") no-repeat;
    background-size: 100% 100%;
  }
}
.file-box-item {
  margin-bottom: 0.2667rem;
  width: 2.4rem;
  height: 2.4rem;
  margin-right: 0.2rem;
  display: flex;
  flex-direction: column;
  img {
    height: 100%;
    width: 100%;
  }
}
.title {
  flex: 1;
  font-size: 0.3733rem;
  color: #666;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.bottom-box {
  width: 100%;
  height: 0.48rem;
  line-height: 0.48rem;
  display: flex;
  overflow: hidden;
  .icon {
    flex: 1;
    min-width: 0.48rem;
    height: 100%;
    background: rosybrown;
  }
  .fileformat-excel {
    background: url("../../../assets/icon/excel.png") no-repeat;
    background-size: 0.48rem 0.48rem;
  }
  .fileformat-text {
    background: url("../../../assets/icon/text.png") no-repeat;
    background-size: 0.48rem 0.48rem;
  }
  .fileformat-word {
    background: url("../../../assets/icon/word.png") no-repeat;
    background-size: 0.48rem 0.48rem;
  }
  .fileformat-zip {
    background: url("../../../assets/icon/zip.png") no-repeat;
    background-size: 0.48rem 0.48rem;
  }
  .fileformat-video {
    background: url("../../../assets/icon/video.png") no-repeat;
    background-size: 0.48rem 0.48rem;
  }
  .fileformat-pdf {
    background: url("../../../assets/icon/pdf.png") no-repeat;
    background-size: 0.48rem 0.48rem;
  }
  .fileformat-ppt {
    background: url("../../../assets/icon/ppt.png") no-repeat;
    background-size: 0.48rem 0.48rem;
  }
  .fileformat-tong {
    background: url("../../../assets/icon/tong.png") no-repeat;
    background-size: 0.48rem 0.48rem;
  }
  .size {
    margin-left: 0.2267rem;
    font-size: 0.3733rem;
    color: #999999;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Share/Preview/filesItemSwiper.vue